/**
 * 模块名称: 合同管理详情页
 * @author liujingxue@372163.com
 */

import React, { useState, useEffect } from 'react'
import {
  Descriptions,
  Spin,
  Icon,
  message,
  Steps,
  Button,
  Modal,
  Input,
  Popconfirm,
  Form,
  Select,
  Table,
  Tooltip,
  Radio,
} from 'antd'
import api from '@/api'
import { parseSearch, debounce, judgeCryptoParamsUrl } from '@/utils'

const FormItem = Form.Item
const {Option} = Select
const { Step } = Steps
const DItem = Descriptions.Item

let areaTxt = '', areaTxts = '', result = ''
let receiveTimer = null

const Details = (props) => {
  const { history, location } = props
  const search = parseSearch(location.search)
  const { getFieldDecorator } = props.form
  const [detail, setDetail] = useState({})
  const [flow, setFlow] = useState([])
  const [modalVisible, setModalVisible] = useState(false)
  const [auditRecord, setAuditRecord] = useState([])
  const [loading, setLoading] = useState(true)
  const [resPlaceholder, setResPlaceholder] = useState('请输入至少1个字符')
  const [files, setFiles] = useState([])
  const [projectDetail, setProjectDetail] = useState({})
  const [receiverValue, setReceiverValue] = useState('')
  //领取人列表
  const [receiveList, setReceiveList] = useState([])
  const [val, setVal] = useState('')
  const [staffNo, setStaffNo] = useState('')
  //验证是否检测完合同号
  const [checkContractNo, setCheckContractNo] = useState(false)
  //核销 已回 退回 归档
  const [contractVisible, setContractVisible] = useState(false)
  const [contractVal, setContractVal] = useState('')
  const [contractId, setContractId] = useState('')
  //操作权限
  const [auditAuth, setAuditAuth] = useState(false)//设置按钮组是否展示
  const [hasChargerPower, setHasChargerPower] = useState(false)//设置驳回和通过按钮是否展示
  const [replenish, setReplenish] = useState(false)//设置补充资料按钮是否展示
  const [returnUp, setReturnUp] = useState(false)//设置转上级按钮是否展示
  const [rejectMsgRequire, setRejectMsgRequire] = useState(false)//设置审批意见驳回必填
  const [ctrt_products, setCtrt_products] = useState({})
  const [fuzerens, setFuzerens] = useState([])
  const [ctrt_product_all, setCtrt_product_all] = useState({})
  const [ctrt_productsList, setCtrt_productsList] = useState([])
  const [saleServiceName, setSaleServiceName] = useState('')  //营销服务，项目名
  const [areaSale, setAreaSale] = useState('') //地区销售授权
  const [redBookData, setRedBookData] = useState({}) // 小红书数据
  const [contractData, setContractData] = useState({})

  useEffect(() => {
    if (judgeCryptoParamsUrl(search)) {
      areaTxt = ''
      areaTxts = ''
      result = ''
      if (search.contractNo) {
        getLeaveOutRow(undefined, search.contractNo)
      } else if (search.id) {
        getLeaveOutRow(search.id)
      }
    } else {
      message.error('没有本页访问权限')
      setTimeout(() => {
        history.go(-2)
      }, 1000)
    }
  }, [])

  //获取详情
  const getLeaveOutRow = (id, contractNo) => {
    let params = {
      type: 0
    }
    if (contractNo) {
      params.contractNo = contractNo
    } else {
      params.id = id
    }
    api.getFortuneContractDetail(params).then(res => {
      if (search.msgId) {
        api.setMessageReaded({ ids: [search.msgId] })
      }
      if (JSON.stringify(res) !== "[]") {
        let data = Object.assign({}, res)
        if (data.status === 0) data.current = 0
        if (data.status === 1) data.current = 1
        if (data.status === 2) data.current = 2
        if (data.status === 3) data.current = 3
        data.files && setFiles(JSON.parse(data.files))
        if(data.templateId == 9) {
          const obj = JSON.parse(data.contractData)
          setCtrt_products(obj.ctrt_products[0])
          setFuzerens(obj.fuzerens)
        }
        if (data.templateId == 10 || data.templateId == 11 || data.templateId == 16 || data.templateId == 17) {
          const obj = JSON.parse(data.contractData)
          setCtrt_product_all(obj.ctrt_product_all)
        }
        if (data.templateId == 12 || data.templateId == 13 || data.templateId == 18 || data.templateId == 19) {
          const obj = JSON.parse(data.contractData)
          setSaleServiceName(obj.saleServiceName)
          setAreaSale(obj.areaSale)
          setCtrt_productsList(obj.ctrt_products)
        }
        if (data.templateId == 14) {
          const obj = JSON.parse(data.contractData)
          setRedBookData(obj.serviceInfo)
        }
        if ([15, 22, 23].includes(data.templateId)) {
          const obj = JSON.parse(data.contractData)
          setContractData(obj)
        }
        if (data.productsDetail !== 'null') {
          setProjectDetail(JSON.parse(data.productsDetail))
        }
        setDetail(data)
        if (data.luruhetongFlag) {
          setReceiverValue(data.receiver)
          setStaffNo(data.staffNo)
          api.getContractStaffList({ userName: data.receiver }).then(res => {
            setReceiveList(res)
          })
        }
        let auditFlow = data.audit_flow
        auditFlow.forEach((item, index, self) => {
          if (item.persons && item.persons.length) {
            self[index].persons = item.persons.join('，')
          }
        })
        setFlow(auditFlow)
        setAuditRecord(data.audit_log)
        if (data.auditAuth && JSON.stringify(data.auditAuth) !== '[]') {
          setAuditAuth(true)
          setHasChargerPower(data.auditAuth.hasChargerPower)
          setReplenish(data.auditAuth.replenish)
          setReturnUp(data.auditAuth.return_up)
          setRejectMsgRequire(data.auditAuth.reject_msg_require)
        } else {
          setAuditAuth(false)
          setHasChargerPower(false)
          setReplenish(false)
          setReturnUp(false)
          setRejectMsgRequire(false)
        }
      } else {
        setDetail({})
        setFlow([])
        setAuditRecord([])
      }
      setLoading(false)
    })
  }
  //点击4个审批的按钮
  const leaveOutAudit = (no) => {
    areaTxt = ''
    result = no
    if (no == 0) {//eslint-disable-line
      if (detail.luruhetongFlag) {
        if (checkContractNo) {
          return message.warning('正在验证合同号的有效性，请稍候再点击提交。')
        }
        if (val == '') {
          return message.warning('请输入合同号或合同号已存在')
        }
        setResPlaceholder('请输入审批意见')
        setModalVisible(true)
      } else {
        setResPlaceholder('请输入审批意见')
        setModalVisible(true)
      }
     
    } else if (no == 1) {//eslint-disable-line
      //审批意见是否为必填项改由审批流控制 2020年2月22日 17:19:14
      setResPlaceholder('请输入审批意见')
      setModalVisible(true)
    } else {
      api.getFortuneContractAudit({
        id: detail.id,
        type: result,
        remark: areaTxt
      }).then(res => {
        //todo 转上级或者补充资料 返回列表页
        let timer = setTimeout(() => {
          history.push({
            pathname: '/protocol/contract'
          })
          clearTimeout(timer)
        }, 1000)
      })
    }
  }
  const oprateHandleOk = () => {
    if (areaTxt.length < 1 && result == 1 && rejectMsgRequire) {//eslint-disable-line
      message.warning('请输入至少1个字符')
      return
    }
    let params = {
      id: detail.id,
      type: result,
      remark: areaTxt,
    }


    if (detail.luruhetongFlag && detail.isOld == 0 && result == 0 && val) {
      params.contractNo = val
    }
    api.getFortuneContractAudit(params).then(res => {
      message.success('审批成功')
      setModalVisible(false)
      getLeaveOutRow(detail.id)
    })
  }
  //取消弹窗
  const oprateHandleCancel = () => {
    setModalVisible(false)
  }
  //同意的样式
  const agreeNode = () => {
    return result === 0 ? <>
      通过 <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
    </> : result === 1 ? <>驳回 <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" /></> : 
    <>转上级</>
  }
  //审批意见
  const getAreaTxt = (e) => {
    areaTxt = e.target.value.trim()
  }

  //获取领取人
  const onChangeReceiver = (value, option) => {
    if (Array.isArray(option.props.children)) {
      let arr = option.props.children[0]
      setReceiverValue(arr)
    } else {
      setReceiverValue(option.props.children)
    }
  }

  const geReceiveList = (value) => {
    let val = value.trim()
    if (val !== '') {
      if(receiveTimer){
        clearTimeout(receiveTimer)
      }
      receiveTimer = setTimeout(() => {
        receiveTimer = null
        clearTimeout(receiveTimer)
        api.getContractStaffList({ userName: val }).then(res => {
          setReceiveList(res)
        })
      }, 1000)
    }else{
      receiveTimer = setTimeout(() => {
        receiveTimer = null
        clearTimeout(receiveTimer)
        setReceiveList([])
      }, 2000)
    }
  }

  //获取合同号
  const onChangeContractNo = (e) => {
    setVal(e.target.value.trim())
  }

  const onKeyUp = () => {
    if(val !== '') {
      setCheckContractNo(true)
      api.getFortuneContractCheckContractNo({contractNo: val}).then(res => {
        if (res.constructor === Object) {
          setVal('')
        }
        setCheckContractNo(false)
      }).catch(err => console.log(err))
    }
  }

  //修改领取人信息
  const onReceiver = () => {
    setLoading(true)
    if (!receiveList.length > 0) {
      setLoading(false)
      return message.warning('领取人不存在')
    }
    api.getFortuneContractAddReciverInfo({
      id: detail.id,
      reciver: receiverValue
    }).then(res => {
      message.success('修改成功')
      getLeaveOutRow(detail.id)
      setLoading(false)
    }).catch(err => setLoading(false))
  }

  //核销 已回 退回 归档确认框
  const onContractOk = () => {
    ContractOperations(contractId)
  }

  //核销 已回 退回 归档的审批意见
  const getAreaTxts = (e) => {
    areaTxts = e.target.value.trim()
  }

  const ContractOperation = (index, val) => {
    areaTxts = ''
    setContractVisible(true)
    setContractVal(val)
    setContractId(index)
  }

  //合同操作
  const ContractOperations = (index) => {
    setLoading(true)
    api.getFortuneContractOperate({
      id: detail.id,
      type: index,
      remark: areaTxts
    }).then(res => {
      setContractVisible(false)
      message.success('修改成功')
      getLeaveOutRow(detail.id)
      setLoading(false)
    }).catch(error => setLoading(false))
  }

  //待领取
  const ContractOperationdailingqu = (index) => {
    setLoading(true)
    api.getFortuneContractOperate({
      id: detail.id,
      type: index
    }).then(res => {
      message.success('修改成功')
      getLeaveOutRow(detail.id)
      setLoading(false)
    }).catch(error => setLoading(false))
  }

  const redColumns = [
    {
      title: " ",
      dataIndex: "partyType",
      key: "partyType",
      width: "10%",
    }, {
      title: <><span style={{ color: "red" }}>*</span>负责人</>,
      dataIndex: "contactPerson",
      key: "contactPerson",
      align: 'center',
    }, {
      title: <><span style={{ color: "red" }}>*</span>联系电话</>,
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      align: 'center',
    }, {
      title: <><span style={{ color: "red" }}>*</span>授权邮箱</>,
      dataIndex: "emailAddress",
      key: "emailAddress",
      align: 'center',
    }, {
      title: <><span style={{ color: "red" }}>*</span>授权邮箱后缀</>,
      dataIndex: "emailSuffix",
      key: "emailSuffix",
      align: 'center',
    }
  ]

  const vrRentalColumns = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      width: 80,
      align: 'center',
      render: (text, record, index) => index + 1,
    },
    {
      title: '设备品牌',
      dataIndex: 'device_brand',
      key: 'device_brand',
      align: 'center',
      width: 120,
    },
    {
      title: '设备型号及配置',
      dataIndex: 'device_model',
      key: 'device_model',
      align: 'center',
      width: 180,
    },
    {
      title: '单位',
      dataIndex: 'unit',
      align: 'center',
      key: 'unit',
      width: 80,
    },
    {
      title: '产品包含配件详情',
      dataIndex: 'accessories',
      align: 'center',
      key: 'accessories',
      render: (accessories) => (
        <div>
          {accessories.map((item, i) => (
            <div key={i}>{item}</div>
          ))}
        </div>
      ),
    },
    {
      title: '设备数量',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'center',
      width: 100,
      render: (text) => text || '-',
    },
    {
      title: '租赁费用(元/套/月)',
      dataIndex: 'monthly_rental_fee',
      key: 'monthly_rental_fee',
      align: 'center',
      width: 150,
      render: (text) => text || '-',
    },
  ]

  return (
    <>
      <Spin spinning={loading}>
        <Button 
          onClick={() => history.goBack()}
          type="primary" 
          style={{
            position: 'absolute',
            right: 0,
            top: '-20px'
          }}
        >返回上一页</Button>
        <div className="contract-header" style={{padding: '20px 0'}}>
          <div>
            <div style={{ fontSize: '16px', marginBottom: '10px', color: '#000' }}>审批详情</div>
            <div style={{ fontSize: '12px', marginBottom: '5px', color: '#000' }}>
              合同业务编号：<span style={{ fontSize: '16px' }}>{detail.businessNo}</span>
            </div>
          </div>
          {
            [6, 20, 21].includes(detail.templateId) || detail.businessType == 1 ? null : (
              <form id="upload" method="get" action="/api/fortune/Contract/Preview" target="_blank">
                <input type="hidden" name="id" value={search.id} />
                <Button htmlType="submit">合同预览</Button>
              </form> 
            )
          }
        </div>
        <div className="line"></div>
        <div className="step-wrap">
          <div className="contract-list-title">当前进度</div>
          <Steps current={detail.current}>
            {
              flow.map((item, index, self) => {
                let status = 'wait'
                if (item.time && item.time.length > 1) {
                  status = 'process'
                }
                return <Step status={status} title={item.nodeName} key={index} description={
                  <>
                    {item.persons && <div title={item.persons}>{item.persons}</div>}
                    <div title={item.statusName}>{item.statusName}</div>
                    <div title={item.time}>{item.time}</div>
                  </>
                } />
              })
            }
          </Steps>
        </div>
        <div className="line"></div>
        <Descriptions title="合同信息" layout="vertical" column={4} className="order-detail-title" style={{ borderBottom: 'none', marginTop: '10px' }}>
          <DItem label="合同主体">{detail.accountName}</DItem>
          {[6, 20, 21].includes(detail.templateId) && <>
            <DItem label="类型">{detail.clientSource == 0 ? '直销' : '代理商'}</DItem>
            <DItem label={detail.clientSource == 0 ? 'OAID' : '代理商名称'}>{detail.clientSource == 0 ? detail.customerId : detail.customerName}</DItem>
          </>}
          <DItem label="合同模板">{detail.templateTypeName}</DItem>
          {
            detail.businessTypeName && <DItem label="业务类型">{detail.businessTypeName ? detail.businessTypeName : '无'}</DItem>
          }
          <DItem label="一式几份">{detail.copies}</DItem>
          {detail.templateId == 15 && <DItem label="双方各执几份">{contractData.copies_num}</DItem>}
          <DItem label="领取人">
            {detail.luruhetongFlag ? <FormItem>
              {getFieldDecorator('receiveId', {
                initialValue: receiverValue + '' + ' ' + staffNo,
                rules: [{ required: true, message: '请输入领取人' }]
              })(<Select
                showSearch
                showArrow
                placeholder="请输入领取人"
                onSearch={geReceiveList}
                onChange={onChangeReceiver}
                notFoundContent='未搜索到相关领取人'
                filterOption={false}
                style={{ width: 180 }}
              >
                {receiveList.map((item, index) => <Option key={index} value={item.id}>{item.staffName} {item.staffNo}</Option>)}
              </Select>)}
              <Button style={{marginLeft: '20px'}} type="primary" size="small" onClick={onReceiver}>保存</Button>
            </FormItem> : <div>{detail.receiver}</div>} 
          </DItem>
          <DItem label="合同号">{detail.contractNo}</DItem>
          <DItem label="责任人">{detail.liablerName}</DItem>
          <DItem label="OAID/QID">{detail.clientSource == 0 ? detail.customerId : detail.channelQid}</DItem>
          {[12, 13, 18, 19].includes(detail.templateId) && <>
            <DItem label="代理期限">{detail.beginTime}至{detail.endTime}</DItem>
            <DItem label="营销服务">{saleServiceName}</DItem>
            <DItem label="地区销售授权">{areaSale}</DItem>
          </>}
          {[10, 11, 16, 17].includes(detail.templateId) && <DItem label="服务期限">{detail.beginTime}至{detail.endTime}</DItem>}
          {detail.templateId === 14  && <DItem label="服务期间">{detail.beginTime}至{detail.endTime}</DItem>}
          {detail.templateId === 15  && <DItem label="租赁期限">{detail.beginTime}至{detail.endTime}</DItem>}
          <DItem label={
            <span>
              运营属性
              <Tooltip title={<span style={{ color: '#fff' }}>代运营服务类直销、代理商客户，公司提供创意搭建、数据优化运营、数据分析等服务；
                自运营类直销、代理商客户，公司仅提供账户充值服务。
              </span>}>
                <Icon type="info-circle" style={{ marginLeft: 4, cursor: 'pointer' }} />
              </Tooltip>
            </span>
          }>{detail.operationalAttributesName || '-'}</DItem>
          {detail.templateId === 22  && <DItem label="活动期限">{detail.beginTime}至{detail.endTime}</DItem>}
        </Descriptions>
        {![9, 12, 13, 14, 15, 18, 19, 22, 23].includes(detail.templateId) && <>
          <div className="line"></div>
          <Descriptions title="投放媒体" layout="horizontal" column={8} className="order-detail-title" style={{ marginTop: '10px', borderBottom: 'none' }}>
            <DItem label="">
              {
                projectDetail[0] && projectDetail[0].project ? projectDetail[0].project.map((v, i) => {
                  return <div key={i}>{v.label}：</div>
                }) : null
              }
            </DItem>
            <DItem label="">
              {
                projectDetail[1] && projectDetail[1].product ? projectDetail[1].product.map((v, i) => {
                  return <div key={i}>{v.label}</div>
                }) : null
              }
            </DItem>
            <DItem label=""></DItem>
            <DItem label=""></DItem>
            <DItem label=""></DItem>
            <DItem label=""></DItem>
            <DItem label=""></DItem>
            <DItem label=""></DItem>
          </Descriptions>
        </>}
        {[12, 13, 18, 19].includes(detail.templateId) && <>
          <div className="line"></div>
          <Descriptions title="推广服务内容" layout="horizontal" column={1} className="order-detail-title" style={{ marginTop: '10px', borderBottom: 'none' }}>
            <DItem label="">
              {
                ctrt_productsList.length > 0 ? ctrt_productsList.map((v, i) => {
                  return <div key={i} style={{ display: 'flex'}}>
                    <div style={{ width: '400px'}}><span style={{ fontWeight: '800',fontSize: '15px'}}>投放媒体：</span>{v.projectName}</div>
                    <div style={{ marginLeft: '20px'}}><span style={{ fontWeight: '800',fontSize: '15px'}}>返点：</span>{v.fandian}</div>
                  </div>
                }) : null
              }
            </DItem>
          </Descriptions>
        </>}
        {[10, 11, 16, 17].includes(detail.templateId) && <>
          <div className="line"></div>
          <Descriptions title="推广服务内容" layout="vertical" column={2} className="order-detail-title" style={{ borderBottom: 'none', marginTop: '10px' }}>
            <DItem label="推广费总计">{ctrt_product_all.receiptFeeAll}元整（大写：{ctrt_product_all.receiptFeeAllCapital}）</DItem>
            <DItem label="不含税价款">{ctrt_product_all.buhan_shui}元</DItem>
            <DItem label="增值税额">{ctrt_product_all.zengzhi_shui}元</DItem>
            <DItem label="税率">{ctrt_product_all.taxRate}%</DItem>
          </Descriptions>
        </>}
        {detail.templateId == 9 && <>
          <Descriptions title="推广服务内容" layout="vertical" column={2} className="order-detail-title" style={{ borderBottom: 'none', marginTop: '10px' }}>
            <DItem label="结算方式">{ctrt_products.settlementType}</DItem>
            <DItem label="服务费">{ctrt_products.settlementNum}</DItem>
          </Descriptions>
          {fuzerens.length > 0 && fuzerens.map((item, index) => {
            return <Descriptions title={<div style={{ fontSize: '14px'}}>委托账户及负责的人信息</div>} column={4} key={index} style={{ borderBottom: 'none', marginTop: '10px' }}>
              <DItem label="账户名称">{item.accountName}</DItem>
              <DItem label="公司名称">{item.companyName}</DItem>
              <DItem label="代运营媒体">{item.meiti}</DItem>
              <DItem label="账号ID">{item.accountNum}</DItem>
              <DItem label="姓名">{item.name}</DItem>
              <DItem label="联系电话">{item.tel}</DItem>
              <DItem label="微信号码">{item.weixin}</DItem>
              <DItem label="QQ号码">{item.qq}</DItem>
              <DItem label="电子邮箱">{item.email}</DItem>
              <DItem label="传真号码">{item.fax}</DItem>
            </Descriptions>
          })}
        </>}
        {![22, 23].includes(detail.templateId) && <>
          <div className="line"></div>
          <Descriptions title="签约信息" layout="vertical" column={2} className="order-detail-title" style={{ marginTop: '10px', borderBottom: 'none' }}>
            <DItem label={detail.templateId === 15 ? "甲方（租赁方）" : "甲方"}>{detail.partA}</DItem>
            <DItem label={detail.templateId === 15 ? "乙方（出租方）" : "乙方"}>{detail.partB}</DItem>
          </Descriptions>
        </>}
        {detail.templateId === 22 && <>
          <div className="line"></div>
          <Descriptions title="签约信息" layout="vertical" column={2} className="order-detail-title" style={{ marginTop: '10px', borderBottom: 'none' }}>
          </Descriptions>
          <div className="all-space-info-super">
            <div className="info-list">
              <div className="item">
                <div className="label">甲方（委托方）</div>
              </div>
              <div className="item">
                <div className="label">名称:</div>
                <div className="value">{contractData.partA.name}</div>
              </div>
              <div className="item">
                <div className="label">统一社会信用代码/身份证号:</div>
                <div className="value">{contractData.partA.account}</div>
              </div>
            </div>
            <div className="info-list">
              <div className="item">
                <div className="label">乙方（服务提供方）</div>
              </div>
              <div className="item">
                <div className="label">名称:</div>
                <div className="value">{contractData.partB.name}</div>
              </div>
              <div className="item">
                <div className="label">统一社会信用代码/身份证号:</div>
                <div className="value">{contractData.partB.account}</div>
              </div>
              <div className="item">
                <div className="label">项目经理姓名:</div>
                <div className="value">{contractData.partB.manager}</div>
              </div>
              <div className="item">
                <div className="label">项目经理电话:</div>
                <div className="value">{contractData.partB.manager_tel}</div>
              </div>
            </div>
          </div>
          <div className="line"></div>
          <Descriptions title="活动费用与开票信息" layout="vertical" column={2} className="order-detail-title" style={{ marginTop: '10px', borderBottom: 'none' }}>
          </Descriptions>
          <div className="all-space-info-super">
            <div className="info-list">
              <div className="item">
                <div className="label">活动费用:</div>
              </div>
              <div className="item">
                <div className="label">本活动服务费用（含税）:</div>
                <div className="value">{contractData.activity_fee.activity_service_fee}元/人</div>
              </div>
              <div className="item">
                <div className="label">本活动参加人数:</div>
                <div className="value">{contractData.activity_fee.activity_num}位</div>
              </div>
              <div className="item">
                <div className="label">本活动服务总费用:</div>
                <div className="value">{contractData.activity_fee.activity_service_total_fee}元</div>
              </div>
              <div className="item">
                <div className="label">增值服务费用:</div>
                <div className="value">{contractData.activity_fee.value_added_service_fee}元/场</div>
              </div>
              <div className="item">
                <div className="label">本活动总费用:</div>
                <div className="value">{contractData.activity_fee.activity_total_fee}元</div>
              </div>
            </div>
            <div className="info-list">
              <div className="item">
                <div className="label">甲方开票信息</div>
              </div>
              <div className="item">
                <div className="label">发票类型:</div>
                <div className="value">
                  <Radio.Group value={contractData.invoice_info.invoice_type}>
                    <Radio value="1" disabled>增值税专用发票</Radio>
                    <Radio value="2" disabled>增值税普通发票</Radio>
                  </Radio.Group>
                </div>
              </div>
              <div className="item">
                <div className="label">发票内容:</div>
                <div className="value">
                  <Radio.Group value={contractData.invoice_info.invoice_content}>
                    <Radio value="1" disabled>*现代服务*服务费*</Radio>
                    <Radio value="2" disabled>*会展服务*会议费</Radio>
                  </Radio.Group>
                </div>
              </div>
            </div>
          </div>
        </>}
        {detail.templateId === 23 && <>
          <div className="line"></div>
          <Descriptions title="签约信息" layout="vertical" column={2} className="order-detail-title" style={{ marginTop: '10px', borderBottom: 'none' }}>
          </Descriptions>
          <div className="all-space-info-super">
            <div className="info-list">
              <div className="item">
                <div className="label">甲方（委托方）</div>
              </div>
              <div className="item">
                <div className="label">名称:</div>
                <div className="value">{detail.partA}</div>
              </div>
              <div className="item">
                <div className="label">联系人:</div>
                <div className="value">{contractData.contactA}</div>
              </div>
              <div className="item">
                <div className="label">联系方式:</div>
                <div className="value">{contractData.mobileA}</div>
              </div>
            </div>
            <div className="info-list">
              <div className="item">
                <div className="label">乙方（服务提供方）</div>
              </div>
              <div className="item">
                <div className="label">名称:</div>
                <div className="value">{detail.partB}</div>
              </div>
            </div>
          </div>
          <div className="line"></div>
          <Descriptions title="产品信息与订阅期间" layout="vertical" column={2} className="order-detail-title" style={{ marginTop: '10px', borderBottom: 'none' }}>
          </Descriptions>
          <div className="all-space-info-super">
            <div className="info-list">
              <div className="item">
                <div className="label" style={{ fontSize: '16px' }}>产品信息1</div>
              </div>
              <div className="item">
                <div className="label">投放媒体:</div>
                <div className="value">{contractData.project1.split('|')[1]}</div>
              </div>
              <div className="item">
                <div className="label">产品:</div>
                <div className="value">{contractData.productName1}</div>
              </div>
              <div className="item">
                <div className="label">订阅类型:</div>
                <div className="value">{contractData.subscriptionType1}</div>
              </div>
              <div className="item">
                <div className="label">工号数量:</div>
                <div className="value">{contractData.workNumber1}</div>
              </div>
              <div className="item">
                <div className="label">价格:</div>
                <div className="value">{contractData.price1.toFixed(2)} 元</div>
              </div>
            </div>
            <div className="info-list">
              <div className="item">
                <div className="label" style={{ fontSize: '16px' }}>产品信息2</div>
              </div>
              <div className="item">
                <div className="label">投放媒体:</div>
                <div className="value">{contractData.project2.split('|')[1]}</div>
              </div>
              <div className="item">
                <div className="label">产品:</div>
                <div className="value">{contractData.productName2}</div>
              </div>
              <div className="item">
                <div className="label">订阅类型:</div>
                <div className="value">{contractData.subscriptionType2}</div>
              </div>
              <div className="item">
                <div className="label">工号数量:</div>
                <div className="value">{contractData.workNumber2}</div>
              </div>
              <div className="item">
                <div className="label">价格:</div>
                <div className="value">{contractData.price2.toFixed(2)} 元</div>
              </div>
            </div>
          </div>
          <div className="subscription_period">
            <div className="label">订阅期间:</div>
            <div className="value">{contractData.subscriptionPeriod}</div>
          </div>
        </>}
        {detail.templateId === 14 && <>
          <div className="line"></div>
          <Descriptions title="服务内容" layout="horizontal" column={1} className="order-detail-title" style={{ marginTop: '10px', borderBottom: 'none' }}>
            <DItem label="">
              {
                <div style={{ display: 'flex' }}>
                  <div style={{ width: '400px' }}><span style={{ fontWeight: '800', fontSize: '14px' }}>媒体：{redBookData?.mediaName}</span></div>
                  <div style={{ marginLeft: '20px' }}><span style={{ fontWeight: '800', fontSize: '14px' }}>服务费用总金额(含税)：{redBookData?.totalServiceFeeInclusiveTax}</span></div>
                </div>
              }
            </DItem>
          </Descriptions>
          <Table
            dataSource={redBookData?.parties}
            columns={redColumns}
            pagination={false}
            bordered
            size="small"
            style={{ margin: '10px 0 20px' }}
          />
        </>}
        {detail.templateId === 15 && <>
          <div className="line"></div>
          <Descriptions title="租赁物品清单" layout="horizontal" column={1} className="order-detail-title" style={{ marginTop: '10px', borderBottom: 'none' }}>
          </Descriptions>
          <Table
            dataSource={contractData?.rental_items}
            columns={vrRentalColumns}
            pagination={false}
            bordered
            size="small"
            style={{ width: '90%' }}
          />
          <div style={{display:'flex', margin: '10px', width: '70%',justifyContent: 'space-between'}}>
            <div className="left-column">
              <div>
                <span>硬件设备押金：{contractData?.deposit}元</span>
                <span style={{marginLeft: '40px'}}>税率：{contractData?.tax_rate}</span>
              </div>
              <div>
                <span>租赁月租金：{contractData?.total_monthly_rent} / 月</span>
                <span style={{marginLeft: '40px'}}>大写：{contractData?.total_monthly_rent_chinese}元 / 月</span>
              </div>
            </div>
            <div>
              <div style={{ display: 'flex'}}>
                <div>其他设备周边配件：</div>
                <div>
                  原装手柄{contractData.other_accessories?.controller_quantity}对，充电器{contractData.other_accessories?.charger_quantity}个，
                  <br />
                  {contractData.other_accessories?.power_bank_type === 1 ? `挂脖充电宝${contractData.other_accessories?.power_bank_one_quantity}个` :
                   `磁吸充电宝${contractData.other_accessories?.power_bank_two_quantity}套(${contractData.other_accessories?.power_bank_base_quantity}个底座${contractData.other_accessories?.power_bank_battery_quantity}块电池)`
                  }
                  <br />
                  {contractData.other_accessories?.other_context && (
                    <div>{contractData.other_accessories.other_context}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>}
        {detail.templateId === 15 && <>
          <div className="line"></div>
          <Descriptions title="交货方式与开票信息" layout="horizontal" column={1} className="order-detail-title" style={{ marginTop: '10px', borderBottom: 'none' }}>
          </Descriptions>
          {<div style={{ display: 'flex', justifyContent: 'space-between', width: '80%', paddingBottom: 20, lineHeight: '24px' }}>
            <div style={{ width: '48%' }}>
              {[
                ['交货方式', contractData.delivery_info.delivery_method],
                ['交货时间', `${contractData.delivery_info.delivery_days || ''} 个工作日内`]
              ].map(([label, value]) => (
                <div style={{ display: 'flex' }} key={label}>
                  <div style={{ width: 140, textAlign: 'right', paddingRight: 8 }}>{label}：</div>
                  <div>{value || ''}</div>
                </div>
              ))}
              {contractData.delivery_info.delivery_method == '送货' && (
                [
                  ['甲方或指定方名称', contractData.delivery_info.company_name],
                  ['指定签收人', contractData.delivery_info.receiver_name],
                  ['移动电话', contractData.delivery_info.receiver_phone],
                  ['送货地址', contractData.delivery_info.delivery_address]
                ].map(([label, value]) => (
                  <div style={{ display: 'flex' }} key={label}>
                    <div style={{ width: 140, textAlign: 'right', paddingRight: 8 }}>{label}：</div>
                    <div>{value || ''}</div>
                  </div>
                ))
              )}
            </div>
            <div style={{ width: '48%' }}>
              {[
                ['公司注册名称', contractData.invoice_info.invoice_company_name],
                ['纳税人识别号', contractData.invoice_info.tax_id],
                ['注册地址', contractData.invoice_info.company_address],
                ['注册电话', contractData.invoice_info.company_phone],
                ['开户银行', contractData.invoice_info.bank_name],
                ['银行账号', contractData.invoice_info.account_number]
              ].map(([label, value]) => (
                <div style={{ display: 'flex' }} key={label}>
                  <div style={{ width: 120, textAlign: 'right', paddingRight: 8 }}>{label}：</div>
                  <div>{value || ''}</div>
                </div>
              ))}
            </div>
          </div>}
        </>}
        <div className="line"></div>
        <Descriptions title="其他信息" layout="horizontal" column={1} className="order-detail-title" style={{ marginTop: '10px', borderBottom: 'none' }}>
          <DItem label="附件">
            <>
              {
                files.length > 0 ? files.map((item, i) => {
                  return <div key={i}><a href={item.url} target="_blank" rel="noopener noreferrer">{item.name}</a></div>
                }) : <div>无</div>
              }
            </>
          </DItem>
          <DItem label="备注">{detail.note ? detail.note : '无'}</DItem>
        </Descriptions>
        <div className="line"></div>
        <div className="record-list" style={{ marginTop: '10px', marginBottom: '50px' }}>
          <Descriptions title="审批记录" layout="vertical" className="pro-detail-title" column={4} style={{ borderBottom: "none", marginBottom: "-30px" }}>
            <DItem label="姓名"></DItem>
            <DItem label="时间"></DItem>
            <DItem label="状态"></DItem>
            <DItem label="审批意见"></DItem>
          </Descriptions>
          {
            auditRecord.map((item, index) => {
              return <Descriptions layout="horizontal" className="pro-detail-title" column={4} key={index} style={{ borderBottom: "none", marginBottom: "-10px" }}>
                <DItem label="">{item.userInfo.staffName}</DItem>
                <DItem label="">{item.addTime}</DItem>
                <DItem label="">{item.status}</DItem>
                <DItem label="">{item.chargeMsg}</DItem>
              </Descriptions>
            })
          }
        </div>
        {/* <div className="line"></div> */}
      </Spin>
      <div className="contract-details-btn">
        <div className="contract-details-btns">
          <div className="contract-details-input">
              {
                detail.luruhetongFlag && detail.isOld == 0 && <div style={ {marginTop: '20px', marginBottom: '20px'}}>
                  合同号：<Input style={{ width: 120 }} onChange={onChangeContractNo} onKeyUp={onKeyUp}/>
                </div>
              }
          </div>
          {detail.guidangFlag && detail.isOld == 0 && <Button type="primary" onClick={() => ContractOperation(4, '归档')}>归档</Button>}
          {detail.hexiaoFlag && detail.isOld == 0 && <Button type="danger" style={{ marginLeft: '15px'}} onClick={() => ContractOperation(3, '核销')}>核销</Button>}
          {detail.tuihuiFlag && detail.isOld == 0 && <Button type="danger" style={{ marginLeft: '15px'}} onClick={() => ContractOperation(2, '退回')}>退回</Button>}
          {detail.yihuiFlag && detail.isOld == 0 && <Button type="primary" style={{ marginLeft: '15px'}} onClick={() => ContractOperation(1, '已回')}>已回</Button>}
          {detail.dailingqu && detail.isOld == 0 && <Popconfirm
            title={`确认领取人领取了合同 ${val !== '' ? val : detail.contractNo} 吗？`}
            onConfirm={debounce(() => {ContractOperationdailingqu(5)}, 3000)}
            okText="确认"
            cancelText="取消"
          >
            <Button type="primary" style={{ marginLeft: '15px'}}>标记已领取</Button>
          </Popconfirm>}
          <Modal
            title={`确认${contractVal}合同 ${val !== '' ? val : detail.contractNo} 吗？`}
            visible={contractVisible}
            onOk={onContractOk}
            onCancel={() => setContractVisible(false)}
            footer={[
              <Button key="back" onClick={() => setContractVisible(false)}>取消</Button>,
              <Button key="submit" type="primary" onClick={debounce(() => {onContractOk()}, 3000)}>确定</Button>
            ]}
          >
            <div className="officework-modal-content">
              <span className="label">审批意见：</span>
              <Input.TextArea className="content-area" placeholder="请输入通过审批意见" onChange={getAreaTxts} rows={4} style={{ width: "100%" }} maxLength={100} />
            </div>
          </Modal>
          {auditAuth && detail.isOld == 0 && <div className="btns">
            {replenish && <Button onClick={debounce(() => {leaveOutAudit(3)}, 3000)} className="orange-btn">补充资料</Button>}
            {returnUp && <Button onClick={debounce(() => {leaveOutAudit(2)}, 3000)} className="orange-btn">转上级</Button>}
            {hasChargerPower && <Button onClick={() => leaveOutAudit(1)} style={{ marginLeft: '15px'}}>驳回</Button>}
            {hasChargerPower && <Button onClick={() => leaveOutAudit(0)} type="primary" style={{ marginLeft: '15px'}}>通过</Button>}
          </div>}
          <Modal
            title={agreeNode()}
            visible={modalVisible}
            onOk={debounce(() => {oprateHandleOk()}, 3000)}
            onCancel={oprateHandleCancel}
            destroyOnClose={true}
            footer={[
              <Button key="back" onClick={oprateHandleCancel}>取消</Button>,
              <Button key="submit" type="primary" onClick={debounce(() => {oprateHandleOk()}, 3000)}>
               确定
              </Button>]}
          >
            <div className="officework-modal-content">
              <span className="label">审批意见：</span><Input.TextArea className="content-area" placeholder={resPlaceholder} onChange={getAreaTxt} rows={4} style={{ width: "100%" }} maxLength={100} />
            </div>
          </Modal>
        </div>
      </div>
    </>
  )
}

export default Form.create()(Details)